import { HTTP } from "../../../http-common";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";
import { Paf } from "../../../models/Paf";

const state = {
  rows: [],
  message: new httpError()
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  addRow(state) {
    state.rows.push(new Paf());
  },
  clearRows(state) {
    state.rows.length = 0;
    state.rows = [];
    state.rows.push(new Paf());
  },
  removeRow(state) {
    state.rows.pop();
  },
  deleteRow(state, index) {
    state.rows.splice(index, 1);
  },
  removePort(state, pafID) {
    if (state.rows.length > 0) {
      for (var index = state.rows.length; index--; ) {
        if (state.rows[index].pafID === pafID) {
          state.rows.splice(index, 1);
        }
      }
    }
  },
  setProgress(state, message) {
    state.message = message;
  },
  setRows(state, port) {
    state.rows.length = 0;
    state.rows = port;
  },
  updateField
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("clearRows");
  },

  populatePorts({ commit, dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(
        "order/GetPortsOnOrder/" + rootState.orders.rows[0].orderID
      );
      response
        .then(function(data) {
          if (data.status === 200) {
            commit("setRows", data.data);
            dispatch(
              "setMessage",
              new httpError({ message: "Retrieved OK", httpStatus: 200 })
            );
          }
          resolve(data.data);
          return;
        })
        .catch(function(err) {
          dispatch(
            "setMessage",
            new httpError({ message: "Error" + err.message, httpStatus: 500 })
          );
          if (err.response.status == 401) {
            reject(401);
          }
          reject(err.response.status);
        });
    });
  },
  addPortsOnOrder({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "order/AddPortOrder/" + rootState.orders.rows[0].orderID,
        state.rows
      );
      response
        .then(data => {
          if (data.status == 200) {
            commit("setRows", data.data);
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  updatePortsOnOrder({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put(
        "order/UpdatePortsOnOrder/" + rootState.orders.rows[0].orderID,
        state.rows
      );
      response
        .then(data => {
          if (data.status == 200) {
            commit("setRows", data.data);
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  async removeRows({ state, commit, rootState }, newVal) {
    //rowCount is the number of rows to finish with
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1]);
      commit("removeRow");
    }
    try {
      var ipexts = await HTTP.delete(
        "order/DeletePortOrder/" + rootState.orders.rows[0].orderID,
        { data: rows }
      );
      return Promise.resolve(ipexts);
    } catch (e) {
      return Promise.reject(e.message);
    }
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
